import React, { createContext, useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import httpService from '../api/httpService';

const AuthContext = createContext(); // create the auth context

// <----- AuthProvider component to wrap the app ----->
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    
    // check localStorage on app load to persist login
    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
            setIsAuthenticated(true);
            const stored = localStorage.getItem('userDetails');
            try {
                setUserDetails(stored ? JSON.parse(stored) : null);
            } catch {
                setUserDetails(null);
            }
        }
        setIsLoading(false); 
    }, []);
    
    // useEffect(() => {
    //     const token = localStorage.getItem('authToken');
    //     if (token) {
    //         // In a real app, validate the token with your backend
    //         setIsAuthenticated(true);
    //         setUserDetails({ username:  localStorage.getItem('userDetails') }); // store minimal user info
    //     }
    // }, []);

    // <----- login function (simulated; replace with real API call) ----->
    const login = async (username, password) => {
        console.log("inside login function")
        await new Promise(resolve => setTimeout(resolve, 1000));

        //Mock authentication (replace with real logic)
        // if (username === 'admin' && password === 'password') {
        //     const token = 'mock-jwt-token'; // In real app, get from API response
        //     localStorage.setItem('authToken', token);
        //     localStorage.setItem('userDetails', username);
        //     console.log("Autentication true")
        //     setIsAuthenticated(true);
        //     setUserDetails({ username });
        //     return { success: true };
        // } else {
        //     return { success: false, error: 'Invalid username or password' };
        // }

        // const result = await httpService.postData('/login', {username:username, password:password}); 
        const result = await httpService.postData('/login', {username:username, password:password}); 
        if(result.isSuccess){      
            localStorage.setItem("userDetails", JSON.stringify(result.retObject));
            localStorage.setItem("authToken", "dummy-token");
            // localStorage.setItem("authToken", result.retObject.token);
            setIsAuthenticated(true);
            setUserDetails(result.retObject);
            //return result.retObject; 
             return { success: true };       
        }else{
            return { success: false, error: 'Invalid username or password' };
            // setAuthError(result.message);
            // return null;
        } 
    };

    // <----- logout function ----->
    const logout = (navigate) => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userDetails');
        setIsAuthenticated(false);
        setUserDetails(null);
        navigate("/");
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, userDetails, login, logout, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext); // custom hook to use AuthContext